// extracted by mini-css-extract-plugin
export default {"wrapper":"ToggleFilters_wrapper__ZdaRm","title":"ToggleFilters_title__X5x3j","toggle":"ToggleFilters_toggle__Z7Ehe","up":"ToggleFilters_up__aJW4K","down":"ToggleFilters_down__OvLfe"};